
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireefef"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireefef"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5X218", function(module, exports) {

$parcel$export(module.exports, "imageMap", () => $4554070dd500beb6$export$c66125bb69fe918a);

































































const $4554070dd500beb6$export$c66125bb69fe918a = {
    'Anna.jpg': new URL((parcelRequire("4SmZI"))),
    'Blaire.jpg': new URL((parcelRequire("9Utqa"))),
    'Duke.jpg': new URL((parcelRequire("6CF5D"))),
    'Ella.jpg': new URL((parcelRequire("lffte"))),
    'Jane.jpg': new URL((parcelRequire("8FwcY"))),
    'Kelly.jpg': new URL((parcelRequire("kGLoe"))),
    'Kikang.jpg': new URL((parcelRequire("8f3St"))),
    'Kun.jpg': new URL((parcelRequire("1FY2W"))),
    'Rachel.jpg': new URL((parcelRequire("kFoIj"))),
    'Sehyun.jpg': new URL((parcelRequire("8IM8n"))),
    'Taegyun.jpg': new URL((parcelRequire("lm2Xa"))),
    'Yony.jpg': new URL((parcelRequire("3O7T6"))),
    'aiden.jpg': new URL((parcelRequire("5y4XK"))),
    'alice.jpg': new URL((parcelRequire("1vWv5"))),
    'byun-og.jpg': new URL((parcelRequire("iesKV"))),
    'byun.jpg': new URL((parcelRequire("gEVPa"))),
    'christine.jpg': new URL((parcelRequire("eiZeT"))),
    'dongmin.png': new URL((parcelRequire("iZ8fB"))),
    'elena.png': new URL((parcelRequire("jW3df"))),
    'ellie.jpg': new URL((parcelRequire("cpq0n"))),
    'hyojung.jpg': new URL((parcelRequire("lE28R"))),
    'ina.jpg': new URL((parcelRequire("byDmL"))),
    'jason.jpg': new URL((parcelRequire("8XX00"))),
    'jingee.jpg': new URL((parcelRequire("gZauI"))),
    'john.jpg': new URL((parcelRequire("bwhk3"))),
    'jy-og.jpg': new URL((parcelRequire("j91Da"))),
    'jy.jpg': new URL((parcelRequire("6eoDR"))),
    'kevin.jpg': new URL((parcelRequire("ciE5A"))),
    'kijun-og.jpg': new URL((parcelRequire("3ETsY"))),
    'kijun.jpg': new URL((parcelRequire("7J6bd"))),
    'minhong.jpg': new URL((parcelRequire("lQOXG"))),
    'sarah.jpg': new URL((parcelRequire("amQOb"))),
    'scott.jpg': new URL((parcelRequire("3lu6R"))),
    'suhjin.jpg': new URL((parcelRequire("7K4rp"))),
    'sunny.jpg': new URL((parcelRequire("dYhZE"))),
    'ted.jpg': new URL((parcelRequire("6tGhm"))),
    'youngjoong.png': new URL((parcelRequire("jwiT8"))),
    '2.06.jpg': new URL((parcelRequire("2nxQq"))),
    '3sigma1.gif': new URL((parcelRequire("ck7fP"))),
    'aura.png': new URL((parcelRequire("lgf6c"))),
    'char.png': new URL((parcelRequire("5bwl3"))),
    'cmu-play.png': new URL((parcelRequire("9h66g"))),
    'cubs4.png': new URL((parcelRequire("cfnab"))),
    'dokdo.png': new URL((parcelRequire("b1p70"))),
    'eco8-2.jpg': new URL((parcelRequire("dS4YW"))),
    'gpt.png': new URL((parcelRequire("7zelG"))),
    'horizon.png': new URL((parcelRequire("lNUGg"))),
    'meta2.png': new URL((parcelRequire("jILxo"))),
    'meta_1.jpg': new URL((parcelRequire("8TyYF"))),
    'mu_1.png': new URL((parcelRequire("iwEDd"))),
    'mu_2.png': new URL((parcelRequire("3SQQv"))),
    'mun.png': new URL((parcelRequire("hABkM"))),
    'nft.webp': new URL((parcelRequire("kWgeP"))),
    'nft3.png': new URL((parcelRequire("ipguj"))),
    'resq.png': new URL((parcelRequire("fRyYj"))),
    'revision.png': new URL((parcelRequire("5vpvK"))),
    'unison.png': new URL((parcelRequire("80GWC"))),
    'xr.png': new URL((parcelRequire("eJFnH"))),
    'zeta3.png': new URL((parcelRequire("6FcDR"))),
    'bridgelab.png': new URL((parcelRequire("gMhi1"))),
    'cherry.jpg': new URL((parcelRequire("beB20"))),
    'chris.jpg': new URL((parcelRequire("9MASs"))),
    'mangotango.png': new URL((parcelRequire("du4NB"))),
    'techno24.png': new URL((parcelRequire("6oQI7"))),
    'techno25.jpg': new URL((parcelRequire("91odg")))
};

});
parcelRegister("4SmZI", function(module, exports) {
module.exports = import.meta.resolve("f7ALq");

});

parcelRegister("9Utqa", function(module, exports) {
module.exports = import.meta.resolve("5HE42");

});

parcelRegister("6CF5D", function(module, exports) {
module.exports = import.meta.resolve("4yHRa");

});

parcelRegister("lffte", function(module, exports) {
module.exports = import.meta.resolve("b3kXl");

});

parcelRegister("8FwcY", function(module, exports) {
module.exports = import.meta.resolve("2gUIX");

});

parcelRegister("kGLoe", function(module, exports) {
module.exports = import.meta.resolve("1VoKD");

});

parcelRegister("8f3St", function(module, exports) {
module.exports = import.meta.resolve("kHTsx");

});

parcelRegister("1FY2W", function(module, exports) {
module.exports = import.meta.resolve("aewHu");

});

parcelRegister("kFoIj", function(module, exports) {
module.exports = import.meta.resolve("3YzX7");

});

parcelRegister("8IM8n", function(module, exports) {
module.exports = import.meta.resolve("iNLAu");

});

parcelRegister("lm2Xa", function(module, exports) {
module.exports = import.meta.resolve("4nG25");

});

parcelRegister("3O7T6", function(module, exports) {
module.exports = import.meta.resolve("gpFGB");

});

parcelRegister("5y4XK", function(module, exports) {
module.exports = import.meta.resolve("cnD2P");

});

parcelRegister("1vWv5", function(module, exports) {
module.exports = import.meta.resolve("51TFV");

});

parcelRegister("iesKV", function(module, exports) {
module.exports = import.meta.resolve("gIMyE");

});

parcelRegister("gEVPa", function(module, exports) {
module.exports = import.meta.resolve("FRj2v");

});

parcelRegister("eiZeT", function(module, exports) {
module.exports = import.meta.resolve("9HtJ5");

});

parcelRegister("iZ8fB", function(module, exports) {
module.exports = import.meta.resolve("s1yjQ");

});

parcelRegister("jW3df", function(module, exports) {
module.exports = import.meta.resolve("9Ic7p");

});

parcelRegister("cpq0n", function(module, exports) {
module.exports = import.meta.resolve("bhuzd");

});

parcelRegister("lE28R", function(module, exports) {
module.exports = import.meta.resolve("22eyJ");

});

parcelRegister("byDmL", function(module, exports) {
module.exports = import.meta.resolve("81S2C");

});

parcelRegister("8XX00", function(module, exports) {
module.exports = import.meta.resolve("aZ8Lw");

});

parcelRegister("gZauI", function(module, exports) {
module.exports = import.meta.resolve("hiMIZ");

});

parcelRegister("bwhk3", function(module, exports) {
module.exports = import.meta.resolve("hjbXU");

});

parcelRegister("j91Da", function(module, exports) {
module.exports = import.meta.resolve("jY2WI");

});

parcelRegister("6eoDR", function(module, exports) {
module.exports = import.meta.resolve("jFNHR");

});

parcelRegister("ciE5A", function(module, exports) {
module.exports = import.meta.resolve("2kkfl");

});

parcelRegister("3ETsY", function(module, exports) {
module.exports = import.meta.resolve("gGIsn");

});

parcelRegister("7J6bd", function(module, exports) {
module.exports = import.meta.resolve("iiIja");

});

parcelRegister("lQOXG", function(module, exports) {
module.exports = import.meta.resolve("gqSQA");

});

parcelRegister("amQOb", function(module, exports) {
module.exports = import.meta.resolve("2GSzT");

});

parcelRegister("3lu6R", function(module, exports) {
module.exports = import.meta.resolve("7aXXL");

});

parcelRegister("7K4rp", function(module, exports) {
module.exports = import.meta.resolve("qE5XC");

});

parcelRegister("dYhZE", function(module, exports) {
module.exports = import.meta.resolve("cp3Rn");

});

parcelRegister("6tGhm", function(module, exports) {
module.exports = import.meta.resolve("fOBHI");

});

parcelRegister("jwiT8", function(module, exports) {
module.exports = import.meta.resolve("gbkrz");

});

parcelRegister("2nxQq", function(module, exports) {
module.exports = import.meta.resolve("gksOW");

});

parcelRegister("ck7fP", function(module, exports) {
module.exports = import.meta.resolve("a2m6h");

});

parcelRegister("lgf6c", function(module, exports) {
module.exports = import.meta.resolve("azBml");

});

parcelRegister("5bwl3", function(module, exports) {
module.exports = import.meta.resolve("dlKr4");

});

parcelRegister("9h66g", function(module, exports) {
module.exports = import.meta.resolve("1CzlQ");

});

parcelRegister("cfnab", function(module, exports) {
module.exports = import.meta.resolve("cjoEC");

});

parcelRegister("b1p70", function(module, exports) {
module.exports = import.meta.resolve("eMnDV");

});

parcelRegister("dS4YW", function(module, exports) {
module.exports = import.meta.resolve("h93bc");

});

parcelRegister("7zelG", function(module, exports) {
module.exports = import.meta.resolve("6Itgm");

});

parcelRegister("lNUGg", function(module, exports) {
module.exports = import.meta.resolve("5PxAD");

});

parcelRegister("jILxo", function(module, exports) {
module.exports = import.meta.resolve("6DvZW");

});

parcelRegister("8TyYF", function(module, exports) {
module.exports = import.meta.resolve("bZVZt");

});

parcelRegister("iwEDd", function(module, exports) {
module.exports = import.meta.resolve("1D9Zz");

});

parcelRegister("3SQQv", function(module, exports) {
module.exports = import.meta.resolve("dBsao");

});

parcelRegister("hABkM", function(module, exports) {
module.exports = import.meta.resolve("eFz4I");

});

parcelRegister("kWgeP", function(module, exports) {
module.exports = import.meta.resolve("iVC1f");

});

parcelRegister("ipguj", function(module, exports) {
module.exports = import.meta.resolve("hrquO");

});

parcelRegister("fRyYj", function(module, exports) {
module.exports = import.meta.resolve("duplA");

});

parcelRegister("5vpvK", function(module, exports) {
module.exports = import.meta.resolve("lH0pa");

});

parcelRegister("80GWC", function(module, exports) {
module.exports = import.meta.resolve("kKoPK");

});

parcelRegister("eJFnH", function(module, exports) {
module.exports = import.meta.resolve("e0Msu");

});

parcelRegister("6FcDR", function(module, exports) {
module.exports = import.meta.resolve("aK4ow");

});

parcelRegister("gMhi1", function(module, exports) {
module.exports = import.meta.resolve("txpUI");

});

parcelRegister("beB20", function(module, exports) {
module.exports = import.meta.resolve("8x2uz");

});

parcelRegister("9MASs", function(module, exports) {
module.exports = import.meta.resolve("16t2w");

});

parcelRegister("du4NB", function(module, exports) {
module.exports = import.meta.resolve("kGV8t");

});

parcelRegister("6oQI7", function(module, exports) {
module.exports = import.meta.resolve("csCZH");

});

parcelRegister("91odg", function(module, exports) {
module.exports = import.meta.resolve("bUgad");

});


var $f39c45f83a337f54$exports = {};
$f39c45f83a337f54$exports = JSON.parse('[{"category":"ONGOING","name":"Project Aura","isApplicationOpen":true,"duration":"2026 Summer ~ 2027 Spring","client":"Harvard Arts Festival","description":"Project AURA\uB294 \uD559\uC0DD\uB4E4\uC758 \uCC3D\uC758\uC131\uACFC \uAC10\uC815\uC744 \uC911\uC2EC\uC73C\uB85C, AI\uB97C \uCC3D\uC791\uC758 \uD611\uC5C5 \uB3C4\uAD6C\uB85C \uD65C\uC6A9\uD558\uB294 Human-Centered Creative AI \uD504\uB85C\uC81D\uD2B8\uC785\uB2C8\uB2E4. \uD559\uC0DD\uB4E4\uC740 \uC74C\uC545, \uAE00\uC4F0\uAE30, \uC2DC\uAC01 \uC608\uC220, \uC778\uD130\uB799\uD2F0\uBE0C \uBBF8\uB514\uC5B4 \uB4F1 \uB2E4\uC591\uD55C \uBD84\uC57C\uC5D0\uC11C \uC790\uC2E0\uC758 \uC544\uC774\uB514\uC5B4\uC640 \uD45C\uD604\uC744 \uAE30\uBC18\uC73C\uB85C AI\uC640 \uD568\uAED8 \uC0C8\uB85C\uC6B4 \uC608\uC220 \uCF58\uD150\uCE20\uC640 \uD50C\uB7AB\uD3FC\uC744 \uC81C\uC791\uD558\uAC8C \uB429\uB2C8\uB2E4. Project AURA\uB294 \uB2E8\uC21C\uD788 AI\uAC00 \uACB0\uACFC\uBB3C\uC744 \uC0DD\uC131\uD558\uB294 \uAC83\uC774 \uC544\uB2C8\uB77C, \uC778\uAC04\uC758 \uCC3D\uC791 \uACFC\uC815\uC744 \uC911\uC2EC\uC73C\uB85C AI\uAC00 \uC774\uB97C \uD655\uC7A5\uD558\uACE0 \uBCF4\uC644\uD558\uB294 collaborative creative process\uB97C \uD0D0\uAD6C\uD558\uB294 \uAC83\uC744 \uBAA9\uD45C\uB85C \uD569\uB2C8\uB2E4. \uC644\uC131\uB41C \uACB0\uACFC\uBB3C\uACFC \uD50C\uB7AB\uD3FC\uC740 Harvard Arts Festival\uC5D0\uC11C \uC804\uC2DC \uBC0F \uD37C\uD3EC\uBA3C\uC2A4 \uD615\uD0DC\uB85C \uACF5\uAC1C\uB420 \uC608\uC815\uC785\uB2C8\uB2E4.","image":"aura.png","objectPosition":"left","deliverables":null,"link":"/capstone/aura"},{"category":"ONGOING","name":"BridgeMUN","isApplicationOpen":true,"duration":"2026 Summer","client":"Apas Camp Lapu-Lapu Middle School","description":"BridgeMUN\uC740 MUN(Model United Nations) \uCC38\uC5EC \uAE30\uD68C\uAC00 \uC81C\uD55C\uB41C \uD559\uC0DD\uB4E4\uB3C4 AI\uC640 \uD568\uAED8 \uAE00\uB85C\uBC8C \uD1A0\uB860\uACFC \uAD6D\uC81C \uC774\uC288\uB97C \uACBD\uD5D8\uD560 \uC218 \uC788\uB3C4\uB85D \uC124\uACC4\uB41C \uAD50\uC721 \uD50C\uB7AB\uD3FC\uC785\uB2C8\uB2E4. \uD559\uC0DD\uB4E4\uC740 AI Delegate\uC640 \uD1A0\uB860\uD558\uBA70 \uAD6D\uAC00\uBCC4 \uC785\uC7A5\uACFC \uC758\uC81C\uB97C \uBD84\uC11D\uD558\uACE0, \uC2E4\uC81C MUN \uBC29\uC2DD\uC758 \uD68C\uC758\uB97C \uC9C1\uC811 \uACBD\uD5D8\uD558\uAC8C \uB429\uB2C8\uB2E4. \uB610\uD55C AI Coaching \uAE30\uB2A5\uC744 \uD1B5\uD574 \uBC1C\uC5B8 \uAD6C\uC131, \uB17C\uB9AC \uC804\uAC1C, \uD1A0\uB860 \uD0DC\uB3C4\uC5D0 \uB300\uD55C \uD53C\uB4DC\uBC31\uC744 \uBC1B\uC73C\uBA70 \uBE44\uD310\uC801 \uC0AC\uACE0\uB825\uACFC \uAE00\uB85C\uBC8C \uCEE4\uBBA4\uB2C8\uCF00\uC774\uC158 \uC5ED\uB7C9\uC744 \uD0A4\uC6B8 \uC218 \uC788\uC2B5\uB2C8\uB2E4. BridgeMUN\uC740 \uC9C0\uC5ED\uACFC \uAD50\uC721 \uD658\uACBD\uC758 \uD55C\uACC4\uB97C \uB118\uC5B4, \uB354 \uB9CE\uC740 \uD559\uC0DD\uB4E4\uC774 \uAE00\uB85C\uBC8C \uD559\uC2B5 \uACBD\uD5D8\uC5D0 \uCC38\uC5EC\uD560 \uC218 \uC788\uB294 \uAE30\uD68C\uB97C \uB9CC\uB4DC\uB294 \uAC83\uC744 \uBAA9\uD45C\uB85C \uD569\uB2C8\uB2E4.","image":"mun.png","objectPosition":"left","deliverables":null,"link":"/capstone/bridgemun"},{"category":"ARCHIVED","name":"Project ResQ","isApplicationOpen":false,"duration":"2026 Summer","client":"Mandaue City Fire Station","description":"Project ResQ\uB294 \uC790\uC5F0\uC7AC\uD574 \uBC1C\uC0DD \uBE48\uB3C4\uAC00 \uB192\uC740 \uC9C0\uC5ED\uC758 \uD654\uC7AC\xb7\uD64D\uC218\xb7\uBD95\uAD34 \uD604\uC7A5\uC5D0 \uBCF4\uB2E4 \uC2E0\uC18D\uD558\uACE0 \uC548\uC804\uD558\uAC8C \uB300\uC751\uD558\uAE30 \uC704\uD574 \uAC1C\uBC1C\uB418\uB294 AI \uAE30\uBC18 \uC7AC\uB09C \uAD6C\uC870 \uD504\uB85C\uC81D\uD2B8\uC785\uB2C8\uB2E4. \uB4DC\uB860\uACFC \uC9C0\uC0C1 \uAD6C\uC870 \uB85C\uBC84\uB97C \uD65C\uC6A9\uD558\uC5EC \uAD6C\uC870\uB300\uAC00 \uC811\uADFC\uD558\uAE30 \uC5B4\uB824\uC6B4 \uC704\uD5D8 \uC9C0\uC5ED\uC758 \uC601\uC0C1\xb7\uC704\uCE58\xb7\uD0D0\uC9C0 \uB370\uC774\uD130\uB97C \uC218\uC9D1\uD558\uACE0, \uC774\uB97C \uAD6C\uC870 \uAE30\uAD00\uC774 \uC2E4\uC2DC\uAC04\uC73C\uB85C \uD655\uC778\uD560 \uC218 \uC788\uB294 \uAD00\uC81C \uC2DC\uC2A4\uD15C\uACFC \uC5F0\uB3D9\uD569\uB2C8\uB2E4. \uB610\uD55C \uD658\uC790\uC758 \uC0C1\uD0DC \uD655\uC778, \uC704\uCE58 \uC804\uB2EC, \uCD08\uAE30 \uC751\uAE09 \uC0C1\uD669 \uD310\uB2E8\uC744 \uC9C0\uC6D0\uD558\uB294 \uAE30\uC220\uC744 \uAC1C\uBC1C\uD558\uC5EC \uC7AC\uB09C \uB300\uC751 \uD6A8\uC728\uC131\uACFC \uC0DD\uC874\uC728 \uD5A5\uC0C1\uC5D0 \uAE30\uC5EC\uD558\uB294 \uAC83\uC744 \uBAA9\uD45C\uB85C \uD569\uB2C8\uB2E4.","image":"resq.png","objectPosition":"left","deliverables":null,"link":"/capstone/resq"},{"category":"ARCHIVED","name":"UNISON Program","isApplicationOpen":false,"duration":"2025 Winter ~ 2026 Spring","client":"SDGIH (SDG Innovation Hub)","description":"UNISON Program\uC740 \uC9C0\uC18D\uAC00\uB2A5\uD55C\uBC1C\uC804(SDG)\uD559\uC2B5\uC5D0 \uAE30\uBC18\uD55C \uAD6D\uC81C \uD559\uC5C5 \uC778\uC99D \uD50C\uB7AB\uD3FC\uC744 \uAC1C\uBC1C\uD569\uB2C8\uB2E4. AI \uD2B8\uB808\uC774\uB2DD\uC744 \uD1B5\uD574 \uAC1C\uBC1C\uB41C \uD559\uC2B5 \uD50C\uB7AB\uD3FC\uC740 \uC804 \uC138\uACC4 \uD559\uC0DD\uB4E4\uC744 \uB300\uC0C1\uC73C\uB85C \uD55C SDG \uAD6D\uC81C \uD559\uC5C5 \uC778\uC99D \uCCB4\uACC4\uC5D0 \uD65C\uC6A9\uB418\uBA70, UN\uC758 SDGIH\uC5D0 \uB3C4\uC785\uB418\uC5B4 \uD65C\uC6A9\uB420 \uC608\uC815\uC785\uB2C8\uB2E4. \uD574\uB2F9 \uD504\uB85C\uADF8\uB7A8\uC740 Columbia University\uC758 Mark Santolucito \uAD50\uC218 (Computer Science \xb7 \uAD50\uC721 \uAE30\uC220 \uBD84\uC57C \uC804\uBB38\uAC00)\uAC00 \uCC38\uC5EC\uD558\uC5EC, AI \uBAA8\uB378 \uC124\uACC4 \uBC0F \uAD50\uC721 \uD50C\uB7AB\uD3FC \uAD6C\uCD95 \uACFC\uC815 \uC804\uBC18\uC5D0 \uB300\uD574 \uC804\uBB38 \uBA58\uD1A0\uB9C1\uACFC \uAE30\uC220 \uC790\uBB38\uC744 \uC81C\uACF5\uD569\uB2C8\uB2E4.","image":"unison.png","objectPosition":"left","deliverables":null,"form":"https://forms.gle/L4KMVFpAh8VMvT6ZA"},{"category":"ARCHIVED","name":"Project Re:vision","isApplicationOpen":false,"duration":"2025 Winter - 2026 Spring","client":"\uC6B0\uB9AC\uB4E4\uC758 \uB208","description":"\uC774 \uD504\uB85C\uC81D\uD2B8\uB294 \uC2DC\uAC01\uC7A5\uC560\uC778\uACFC \uBE44\uC7A5\uC560\uC778\uC758 \uAC10\uAC01 \uACBD\uD5D8\uC744 \uC7AC\uD574\uC11D\uD558\uACE0 \u2018\uBCF8\uB2E4\uB294 \uAC83\u2019\uC758 \uC758\uBBF8\uB97C \uD655\uC7A5\uD558\uB294 \uAC10\uAC01 \uC735\uD569 \uC804\uC2DC \uD504\uB85C\uADF8\uB7A8\uC785\uB2C8\uB2E4. \uC2DC\uAC01 \uC815\uBCF4\uB97C \uC2DC\uAC01 \uC870\uAC74\uC5D0 \uB530\uB978 \uC7AC\uD574\uC11D \uC791\uD488, \uAC10\uAC01 \uC778\uD130\uB799\uC158 \uAE30\uC220, \uAC10\uAC01 \uC804\uD658 \uC54C\uACE0\uB9AC\uC998 \uB4F1\uC744 \uC9C1\uC811 \uC124\uACC4\uD558\uBA70 \u2018\uBCF8\uB2E4\uB294 \uAC83\u2019\uC758 \uC758\uBBF8\uB97C \uB2E4\uC2DC \uC815\uC758\uD558\uB294 \uB2E4\uCE35\uC801 \uC2E4\uD5D8\uC744 \'\uC6B0\uB9AC\uB4E4\uC758 \uB208\u2019\uACFC \uD568\uAED8 \uC218\uD589\uD569\uB2C8\uB2E4.","image":"revision.png","objectPosition":"left","deliverables":null,"form":"https://forms.gle/nn57FPQfQX5cg2SE6"},{"category":"ARCHIVED","name":"Project Horizon","isApplicationOpen":false,"duration":"2025 Summer","client":"Bill & Melinda Gates Foundation","description":"Project Horizon\uC740 AI\uAC00 \uBBF8\uB798 \uC0AC\uD68C\uC5D0 \uBBF8\uCE58\uB294 \uC601\uD5A5, \uC6B0\uB9AC\uC758 \uD604\uC7AC \uC120\uD0DD\uC774 \uBBF8\uB798\uC5D0 \uC5B4\uB5A4 \uACB0\uACFC\uB85C \uC5F0\uACB0\uB418\uB294\uC9C0 \uC2DC\uBBAC\uB808\uC774\uC158\uC744 \uD1B5\uD574 \uAD50\uC721\uD558\uB294 \uD50C\uB7AB\uD3FC\uC785\uB2C8\uB2E4. \uBE4C\uAC8C\uC774\uCE20 \uC7AC\uB2E8 \uB4F1 \uBE44\uC601\uB9AC \uB2E8\uCCB4 \uB3C4\uC785\uC744 \uBAA9\uD45C\uB85C \uD558\uBA70 \uC815\uCC45 \uACB0\uC815, \uC724\uB9AC\uC801 \uD310\uB2E8, \uC0AC\uD68C\uC801 \uAC08\uB4F1 \uD574\uACB0 \uC5ED\uB7C9\uC744 \uB2E4\uB8E8\uB294 AI \uC735\uD569\uD615 \uD504\uB85C\uC81D\uD2B8 \uC785\uB2C8\uB2E4.","image":"horizon.png","objectPosition":"left","deliverables":null,"link":"/capstone/horizon"},{"category":"ARCHIVED","name":"Project Dokdo","duration":"2025 Summer","client":"\uB300\uD55C\uC7A0\uC218\uD611\uD68C","description":"Project Dokdo\uB294 \uD574\uC591\uC218\uC0B0\uBD80 \uC0B0\uD558 \uC0AC\uB2E8\uBC95\uC778 \uB300\uD55C\uC7A0\uC218\uD611\uD68C(KUDA)\uC640 \uD611\uB825\uD558\uC5EC \uCD94\uC9C4\uB418\uB294 \uD504\uB85C\uC81D\uD2B8\uC785\uB2C8\uB2E4. 10~20\uB300 \uCCAD\uC18C\uB144 \uBC0F \uC678\uAD6D\uC778\uC744 \uB300\uC0C1\uC73C\uB85C, \u2018\uB3C5\uB3C4\uB294 \uC6B0\uB9AC \uB545\u2019\uC774\uB77C\uB294 \uC778\uC2DD\uC744 \uC790\uC5F0\uC2A4\uB7FD\uAC8C \uC81C\uACE0\uD560 \uC218 \uC788\uB294 \uCC38\uC5EC\uD615 \uC628\uB77C\uC778 \uCF58\uD150\uCE20 \uD50C\uB7AB\uD3FC\uC744 \uAC1C\uBC1C\uD569\uB2C8\uB2E4. \uD300 \uAE30\uBC18 \uD611\uC5C5\uC744 \uD1B5\uD574 \uBBF8\uC158 \uAC8C\uC784, \uC778\uD130\uB799\uD2F0\uBE0C \uCF58\uD150\uCE20, \uAC00\uC0C1 \uB3C5\uB3C4 \uD0D0\uD5D8 \uB4F1 \uBAB0\uC785\uD615 \uCCB4\uD5D8 \uC694\uC18C\uB97C \uB2F4\uC544 \uD765\uBBF8\uC640 \uAD50\uC721\uC801 \uAC00\uCE58\uB97C \uB3D9\uC2DC\uC5D0 \uCD94\uAD6C\uD569\uB2C8\uB2E4.","image":"dokdo.png","objectPosition":"center","deliverables":null,"link":"/capstone/dokdo"},{"category":"COMPLETED","name":"Project GPT+","client":"Dr. Thomas W. Miller","deliverables":{"name":"Project GPT+ Overview","url":"https://gptdemo-hgnv.onrender.com/"},"duration":"2025 Spring","description":"Project GPT+\uB294 \uC0DD\uC131\uD615 AI\uB97C \uD65C\uC6A9\uD558\uC5EC \uBCF5\uC7A1\uD55C \uD559\uC2B5 \uC8FC\uC81C\uB97C \uCD08\uB4F1\uD559\uC0DD\uB4E4\uC774 \uC27D\uACE0 \uD765\uBBF8\uB86D\uAC8C \uBC30\uC6B8 \uC218 \uC788\uB3C4\uB85D \uB3D5\uB294 \uC6F9 \uAE30\uBC18 \uAD50\uC721 \uD504\uB85C\uC81D\uD2B8\uC785\uB2C8\uB2E4. \uC774 \uD50C\uB7AB\uD3FC\uC740 GPT \uBAA8\uB378\uC744 \uC815\uAD50\uD558\uAC8C \uD29C\uB2DD\uD558\uC5EC, \uD559\uC0DD\uB4E4\uC774 \uC785\uB825\uD55C \uC9C8\uBB38\uC774\uB098 \uC8FC\uC81C\uC5D0 \uB9DE\uCDB0 \uAC1C\uC778\uD654\uB41C \uC0C1\uD638\uC801\uC778 \uB3D9\uD654\uCC45\uC744 \uC0DD\uC131\uD558\uBA70, \uCD94\uC0C1\uC801\uC778 \uAC1C\uB150\uB4E4\uC744 \uCE5C\uADFC\uD558\uACE0 \uAD6C\uCCB4\uC801\uC778 \uC774\uC57C\uAE30\uB85C \uBCC0\uD658\uD558\uACE0 \uD034\uC988\uB3C4 \uD568\uAED8 \uC81C\uACF5\uD569\uB2C8\uB2E4. GPT+\uB294 \uAD50\uC721 \uC790\uC6D0\uC774 \uBD80\uC871\uD55C \uC9C0\uC5ED\uC0AC\uD68C\uC758 \uD559\uC2B5 \uACA9\uCC28\uB97C \uD574\uC18C\uD558\uACE0, \uD3EC\uC6A9\uC801\uC774\uACE0 \uC5ED\uB3D9\uC801\uC778 \uAD50\uC721\uC758 \uC0C8\uB85C\uC6B4 \uBAA8\uB378\uC744 \uC81C\uC2DC\uD569\uB2C8\uB2E4.","image":"gpt.png"},{"category":"COMPLETED","name":"Project XR","client":"CMU Center for Transformational Play","deliverables":{"name":"Project XR Overview","url":"https://xroverview.netlify.app/"},"duration":"2023 Winter - 2024 Spring","description":"\uAC00\uC0C1 \uD604\uC2E4(VR) \uAE30\uC220\uC744 \uD3EC\uD568\uD55C XR \uC0B0\uC5C5\uC740 \uD604\uC7AC Computer Science Departments\uC5D0\uC11C \uAC00\uC7A5 \uAC01\uAD11\uBC1B\uACE0 \uC788\uB294 \uBD84\uC57C \uC911 \uD558\uB098\uC785\uB2C8\uB2E4. \uCE74\uB124\uAE30\uBA5C\uB860 \uB300\uD559\uAD50 Human-Computer Interaction (HCI) Institute \uC0B0\uD558\uC5D0\uC11C \uC9C4\uD589 \uC911\uC778 GIST VR \uD504\uB85C\uC81D\uD2B8\uB97C \uD1B5\uD558\uC5EC \uD559\uC0DD\uB4E4\uC740 \uC0C1\uD638\uC791\uC6A9\uC774 \uAC00\uB2A5\uD55C \uB9DE\uCDA4\uD615 \uAC00\uC0C1 \uD604\uC2E4(VR) \uAE30\uC220\uACFC AI Agent\uB97C \uAC1C\uBC1C\uD558\uC5EC \uC0AC\uC6A9\uC790\uAC00 \uAC00\uC9C0\uACE0 \uC788\uB294 \uBD80\uC815\uC801\uC778 \uC0DD\uAC01, \uAC10\uC815, \uD589\uB3D9 \uB4F1\uC744 \uAE0D\uC815\uC801\uC778 \uBC29\uD5A5\uC73C\uB85C \uC804\uD658\uD560 \uC218 \uC788\uB294 \uBC29\uBC95\uB4E4\uC744 \uAC1C\uBC1C\uD558\uACE0 \uC5F0\uAD6C\uD569\uB2C8\uB2E4.","image":"xr.png"},{"category":"COMPLETED","name":"The Metaverse Project","client":"UPPURPLE","deliverables":null,"duration":"2023 Summer - Fall","description":"\uBA54\uD0C0\uBC84\uC2A4\uB294 4\uCC28 \uC0B0\uC5C5 \uC2DC\uB300\uC5D0 \uAC00\uC7A5 \uB300\uB450\uB418\uB294 \uBD84\uC57C \uC911 \uD558\uB098\uC774\uBA70 \uB2E4\uC591\uD55C \uBD84\uC57C\uC758 \uAE30\uC5C5\uB4E4\uC774 \uD22C\uC790\uC640 \uAC1C\uBC1C\uC744 \uC9C4\uD589\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4. \uC815\uBD80 \uC9C0\uC6D0 \uC0AC\uC5C5\uC73C\uB85C \uC9C4\uD589\uB418\uB294 \uC774\uBC88 \uBA54\uD0C0\uBC84\uC2A4 \uD504\uB85C\uC81D\uD2B8\uB97C \uD1B5\uD574 \uCF54\uB529\uC758 \uCD5C\uC2E0 \uD2B8\uB80C\uB4DC\uB97C \uD559\uC2B5\uD558\uACE0 \uC774\uB97C \uBC14\uD0D5\uC73C\uB85C 4\uCC28 \uC0B0\uC5C5\uC2DC\uB300\uC758 \uC8FC\uC5ED\uC774 \uB420 \uC218 \uC788\uB294 \uAE30\uD68C\uAC00 \uB418\uAE30\uB97C \uBC14\uB78D\uB2C8\uB2E4.","image":"meta_1.jpg"},{"category":"COMPLETED","name":"Project MU","client":"\uC2DD\uBBFC\uC9C0\uC5ED\uC0AC\uBC15\uBB3C\uAD00, \uC6A9\uC0B0 \uC804\uC7C1\uAE30\uB150\uAD00","deliverables":null,"duration":"2023 Summer - Fall","description":"\uC2DD\uBBFC\uC9C0 \uC5ED\uC0AC \uBC15\uBB3C\uAD00\uC740 \uC77C\uC81C \uAC15\uC810\uAE30 \uC2DC\uB300\uC5D0 \uD589\uD574\uC9C4 \uC77C\uC81C\uC758 \uB9CC\uD589\uACFC, \uCE5C\uC77C\uD30C\uB4E4\uC758 \uC88C\uC0C1, \uD22C\uC7C1\uC5D0 \uC5ED\uC0AC\uC5D0 \uAD00\uD55C \uC804\uC2DC\uB97C \uC9C4\uD589\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4. \uC804\uC2DC\uC5D0 \uAD00\uB828\uB41C \uAD6D\uB0B4\uC678 \uD64D\uBCF4\uC640 \uC77C\uBCF8\uC758 \uAD70\uD568\uB3C4 \uC720\uB124\uC2A4\uCF54 \uB4F1\uC7AC\uC640 \uAD00\uB828\uD558\uC5EC \uC804\uC7C1\uAE30\uB150\uAD00 \uC5F4\uB9AC\uB294 \uAE30\uD68D \uC804\uC2DC\uC5D0 \uC778\uD134\uC73C\uB85C \uCC38\uC5EC\uD558\uBA70, \uBC15\uBB3C\uAD00 \uC804\uC6A9 \uBAA8\uBC14\uC77C \uC571\uC744 \uAC1C\uBC1C\uD569\uB2C8\uB2E4.","image":"mu_1.png"},{"category":"COMPLETED","name":"Project CUBS","client":"myKstar (In collaboration with Columbia University 292 Consulting Team)","deliverables":{"name":"The Project CUBS Overview","url":"https://projectcubsoverview.netlify.app/"},"duration":"2023 Spring","description":"\uBCF8 \uD504\uB85C\uC81D\uD2B8\uB294 MyKstar\uB97C \uC704\uD55C \uCC3D\uC758\uC801\uC778 \uC5B8\uC5B4 \uD559\uC2B5 \uD50C\uB7AB\uD3FC \uAC1C\uBC1C\uC744 \uBAA9\uD45C\uB85C \uD569\uB2C8\uB2E4. \uAC1C\uBC1C \uACFC\uC815\uC5D0\uC11C \uD559\uC0DD\uB4E4\uC740 \uCEEC\uB7FC\uBE44\uC544 \uB300\uD559\uAD50 \uB300\uD559\uC6D0\uC758 292 \uCEE8\uC124\uD305 \uD300 \uBA58\uD1A0\uB4E4\uACFC \uD611\uC5C5\uD558\uC5EC \uB2E4\uC591\uD55C \uC5B8\uC5B4 \uD559\uC2B5 \uD50C\uB7AB\uD3FC\uC744 \uBD84\uC11D\uD558\uACE0, \uC0AC\uC6A9\uC790 \uD3B8\uC758\uB97C \uC704\uD55C \uAE30\uB2A5\uACFC \uB514\uC790\uC778, \uC5D4\uD130\uD14C\uC778\uBA3C\uD2B8 \uC694\uC18C \uB4F1\uC744 \uC811\uBAA9\uD558\uC5EC \uD6A8\uACFC\uC801\uC778 \uC5B8\uC5B4 \uD559\uC2B5\uC744 \uB3C4\uC6B8 \uC218 \uC788\uB3C4\uB85D \uD569\uB2C8\uB2E4. \uB610\uD55C, \uC644\uC131\uB41C \uD50C\uB7AB\uD3FC\uC758 \uB2E4\uC591\uD55C \uB9C8\uCF00\uD305 \uC804\uB7B5\uC744 \uACC4\uD68D \uBC0F \uC801\uC6A9\uD558\uC5EC \uD22C\uC790 \uC720\uCE58\uB97C \uC704\uD55C \uC0AC\uC5C5 \uACC4\uD68D\uC744 \uC218\uB9BD\uD569\uB2C8\uB2E4.","image":"cubs4.png"},{"category":"COMPLETED","name":"Project Eco8","client":"\uC81C\uC8FC\uD2B9\uBCC4\uC790\uCE58\uB3C4\uC9C0\uC18D\uAC00\uB2A5\uBC1C\uC804\uD611\uC758\uD68C","deliverables":{"name":"The Project Eco8 Overview","url":"https://eco8overview.netlify.app/"},"duration":"2023 Spring","description":"Project Eco8\uC740 \uC81C\uC8FC\uD2B9\uBCC4\uC790\uCE58\uB3C4\uC9C0\uC18D\uAC00\uB2A5\uBC1C\uC804\uD611\uC758\uD68C\uC758 \uC81C\uC8FC \uBC14\uB78C \uC9C0\uB3C4\uB97C \uB514\uC9C0\uD138\uD654\uD558\uC5EC \uC9C0\uB3C4\uC758 \uBCF4\uAE09\uB960\uC744 \uB192\uC774\uACE0, \uB370\uC774\uD130 \uC0AC\uC774\uC5B8\uC2A4\uB97C \uD65C\uC6A9\uD55C \uB9DE\uCDA4 \uB370\uC774\uD130 \uC81C\uACF5\uC73C\uB85C \uCE5C\uD658\uACBD \uC5C5\uCCB4\uC758 \uCC38\uC5EC\uB3C4\uB97C \uC81C\uACE0\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uD504\uB85C\uC81D\uD2B8\uC5D0 \uCC38\uC5EC\uD558\uB294 \uD559\uC0DD\uB4E4\uC740 \uCF54\uB529\uC744 \uD1B5\uD574 \uC81C\uC8FC\uB3C4\uC758 \uD658\uACBD \uAC1C\uC120\uC5D0 \uC2E4\uC9C8\uC801\uC778 \uB3C4\uC6C0\uC744 \uC904 \uC218 \uC788\uC73C\uBA70, \uC571\uC758 \uC601\uC5B4 \uBC84\uC804 \uC81C\uC791\uC73C\uB85C \uC81C\uC8FC\uB3C4\uB97C \uBC29\uBB38\uD558\uB294 \uC678\uAD6D\uC778\uC5D0\uAC8C\uB3C4 \uCE5C\uD658\uACBD \uD65C\uB3D9\uC744 \uB3C5\uB824\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","image":"eco8-2.jpg","objectFit":"contain"},{"category":"COMPLETED","name":"The NFT Project","client":"\uC0AC\uB2E8\uBC95\uC778 \uB098\uBE44\uC57C\uC0AC\uB791\uD574","deliverables":null,"duration":"2022 Summer","description":"NFT \uD504\uB85C\uC81D\uD2B8\uB294 \uD559\uC0DD\uB4E4\uC774 \uC9C1\uC811 \uB514\uC790\uC778\uD55C 5000\uAC1C\uC758 NFT \uC544\uD2B8 \uC790\uC0B0\uC744 \uC2E4\uC81C OpenSea \uB9C8\uCF13\uC5D0 \uB4F1\uB85D\uD558\uACE0, \uC124\uBB38\uC870\uC0AC\uB97C \uAE30\uBC18\uC73C\uB85C \uD55C \uB9C8\uCF00\uD305 \uD65C\uB3D9\uACFC \uD64D\uBCF4, \uD310\uB9E4 \uD65C\uB3D9\uAE4C\uC9C0 \uC9C4\uD589\uD558\uC600\uC2B5\uB2C8\uB2E4. \uBE14\uB85D\uCCB4\uC778, \uC6F9 \uAC1C\uBC1C, \uB514\uC790\uC778, \uACBD\uC601 \uBD84\uC57C\uC5D0 \uAD00\uC2EC\uC774 \uC788\uB294 \uD559\uC0DD\uB4E4\uC774 NFT \uC790\uC0B0\uC758 \uBBFC\uD305\uC744 \uD1B5\uD574 \uBE14\uB85D\uCCB4\uC778\uC758 \uC0DD\uD0DC\uACC4\uC640 NFT \uC2DC\uC7A5\uC5D0 \uB300\uD55C \uC9C0\uC2DD\uC744 \uC2B5\uB4DD\uD558\uC600\uC73C\uBA70, \uD310\uB9E4 \uC218\uC775 \uC804\uC561\uC744 \uC720\uAE30\uBB18 \uBCF4\uD638\uC18C\uC5D0 \uAE30\uBD80\uD560 \uC218 \uC788\uC5C8\uC2B5\uB2C8\uB2E4.","image":"nft.webp"},{"category":"COMPLETED","name":"Project Planet Plus","client":"\uB300\uD55C\uC801\uC2ED\uC790\uC0AC, \uC0AC\uB2E8\uBC95\uC778 \uB354\uD504\uB77C\uBBF8\uC2A4(\uAD6D\uC81C\uAC1C\uBC1C\uAD6C\uD638\uB2E8\uCCB4)","deliverables":{"name":"The Project Planet Plus Overview","url":"https://planet-plus.netlify.app/"},"duration":"2022 Summer","description":"\uB300\uD55C\uC801\uC2ED\uC790\uC0AC\uC640 \uB354\uD504\uB77C\uBBF8\uC2A4\uC0AC\uAC00 \uC7AC\uB09C \uB300\uC751 \uAD50\uC721\uC744 \uBAA9\uC801\uC73C\uB85C \uAC1C\uBC1C\uD55C \uBCF4\uB4DC\uAC8C\uC784\uC744 \uB514\uC9C0\uD138\uD654\uD558\uC600\uC2B5\uB2C8\uB2E4. \uC138\uACC4 \uAD8C\uC5ED\uBCC4\uB85C \uBE48\uB3C4\uC218\uAC00 \uB192\uC740 \uC7AC\uB09C\uC5D0 \uB9DE\uCDA4 \uAD50\uC721\uC744 \uD560 \uC218 \uC788\uB3C4\uB85D \uAC8C\uC784 \uB0B4 \uC7AC\uB09C \uCE74\uB4DC\uB97C \uB2E4\uC591\uD558\uAC8C \uC81C\uC791\uD558\uC600\uC73C\uBA70, \uD559\uC0DD\uB4E4\uC774 \uAC1C\uBC1C\uD55C \uB514\uC9C0\uD138 \uBC84\uC804\uC758 \uBCF4\uB4DC\uAC8C\uC784\uC740 UN \uC8FC\uCD5C\uB85C \uAC1C\uCD5C\uB41C APMCDRR 2022\uC5D0\uC11C \uB300\uD55C\uC801\uC2ED\uC790\uC0AC\uC5D0 \uC758\uD574 \uBC1C\uD45C\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uD604\uC7AC \uB514\uC9C0\uD138\uD654\uB41C \uBCF4\uB4DC\uAC8C\uC784\uC740 APAC \uC9C0\uC5ED\uC758 \uB2E4\uC591\uD55C \uAD6D\uAC00\uB97C \uBE44\uB86F\uD558\uC5EC \uC804 \uC138\uACC4 \uC5B4\uB9B0\uC774\uB4E4\uC774 \uC0AC\uC6A9\uD560 \uC218 \uC788\uB3C4\uB85D \uC81C\uACF5\uB418\uACE0 \uC788\uC2B5\uB2C8\uB2E4.","image":"2.06.jpg","objectFit":"contain"},{"category":"COMPLETED","name":"Project ZETA","client":"Hygiene Heroes at UC Berkeley","deliverables":{"name":"The Project ZETA Overview","url":"https://hygieneheroes-zeta.netlify.app/"},"duration":"2022 Spring","description":"UC \uBC84\uD074\uB9AC\uC5D0 \uC704\uCE58\uD55C Hygiene Heroes \uC5F0\uAD6C\uC18C\uB294 HAAS \uACBD\uC601 \uB300\uD559\uC6D0\uC758 \uAD50\uC218\uB2D8\uC744 \uC8FC\uCD95\uC73C\uB85C \uAC1C\uBC1C\uB3C4\uC0C1\uAD6D\uC5D0\uC11C \uBC1C\uC0DD\uD558\uB294 \uC9C8\uBCD1\uB4E4\uC744 \uC608\uBC29\uD558\uAE30 \uC704\uD55C \uD65C\uB3D9\uC744 \uD569\uB2C8\uB2E4. \uC138\uADE0\uC131 \uC9C8\uBCD1 \uBC0F \uC218\uC778\uC131 \uC9C8\uBCD1\uC744 \uAC10\uC18C\uC2DC\uD0A4\uAE30 \uC704\uD574 \uC190 \uC53B\uAE30 \uD65C\uB3D9\uC744 \uC7A5\uB824\uD560 \uC218 \uC788\uB294 \uB514\uC9C0\uD138 \uAD50\uC721 \uC790\uB8CC \uC81C\uC791\uACFC \uC62C\uBC14\uB978 \uC190 \uC53B\uAE30 \uD65C\uB3D9\uC744 \uB3C4\uC640\uC8FC\uB294 \uB514\uC2A4\uD39C\uC11C \uAC1C\uBC1C, \uB9C8\uC2A4\uD06C \uB514\uD14D\uD130 \uD504\uB85C\uADF8\uB7A8\uC744 \uC81C\uC791\uD558\uC5EC \uC804\uB2EC\uD558\uC600\uC73C\uBA70, \uBC31\uC2E0 \uC811\uC885\uC744 \uC800\uD574\uD558\uB294 \uC694\uC778 \uBD84\uC11D \uBC0F \uACBD\uAD6C\uC6A9 \uC218\uC561\uC758 \uD6A8\uC728\uC801\uC778 \uBC30\uAE09 \uBC29\uD5A5 \uB4F1\uC744 \uC5F0\uAD6C\uD558\uC5EC Hygiene Heroes\uC758 \uD504\uB85C\uADF8\uB7A8\uB4E4\uC744 \uAC1C\uC120\uD558\uB294\uB370 \uACF5\uD5CC\uD558\uC600\uC2B5\uB2C8\uB2E4.","image":"zeta3.png"},{"category":"COMPLETED","name":"Project 3Sigma","client":"The Primate Portal at Carnegie Mellon University","deliverables":{"name":"The Project 3Sigma Overview","url":"https://www.theprimateportal.org/resources"},"duration":"2021 Fall","description":"\uCE74\uB124\uAE30 \uBA5C\uB860 \uB300\uD559\uAD50\uC640 \uB85C\uCCB4\uC2A4\uD130 \uACF5\uB300\uC758 \uD569\uC791 \uC5F0\uAD6C\uC18C\uC778 The Primate Portal\uC5D0\uC11C \uD65C\uC6A9\uB420 \uC218 \uC788\uB294 \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uBC0F \uD558\uB4DC\uC6E8\uC5B4 \uB4F1\uC744 \uAC1C\uBC1C\uD558\uC600\uC2B5\uB2C8\uB2E4. \uC778\uC9C0\uC2EC\uB9AC\uD559\uC744 \uAE30\uBC18\uC73C\uB85C \uD55C \uB17C\uBB38 \uC791\uC131\uACFC \uC720\uC778\uC6D0\uACFC 5-6\uC138 \uC544\uB3D9\uB4E4\uC758 \uC778\uC9C0 \uB2A5\uB825\uC744 \uBE44\uAD50\uD560 \uC218 \uC788\uB294 \uAC8C\uC784 \uC81C\uC791, \uC5BC\uAD74 \uC778\uC2DD \uBAA8\uB4C8, \uBCF4\uC0C1\uC744 \uC704\uD55C \uB85C\uBCF4\uD2F1\uC2A4 \uAE30\uAE30, \uC6F9\uD398\uC774\uC9C0\uC6A9 \uC544\uD2B8 \uC6CC\uD06C \uC81C\uC791 \uB4F1\uC73C\uB85C \uC5F0\uAD6C \uD65C\uB3D9\uC5D0 \uAE30\uC5EC\uD558\uC600\uC73C\uBA70 \uC5F0\uAD6C\uC758 \uD6A8\uC728\uC131 \uC5ED\uC2DC \uC99D\uC9C4\uC2DC\uD0AC \uC218 \uC788\uC5C8\uC2B5\uB2C8\uB2E4.","image":"3sigma1.gif"},{"category":"COMPLETED","name":"The Capstone Project","client":"\u321C\uC81C\uC77C\uAE30\uD68D(\uC0BC\uC131\uADF8\uB8F9 \uACC4\uC5F4 \uC885\uD569 \uAD11\uACE0\uB300\uD589\uC0AC)","deliverables":null,"duration":"2021","description":"\uC0BC\uC131\uC758 \uC790\uD68C\uC0AC\uC774\uC790 \uB300\uD55C\uBBFC\uAD6D \uCD5C\uB300 \uADDC\uBAA8\uC758 \uAD11\uACE0 \uB300\uD589\uC0AC\uC778 \uC0BC\uC131 \uC81C\uC77C\uAE30\uD68D\uACFC \uD611\uB825\uD558\uC5EC \uAE30\uC5C5 \uB0B4\uBD80\uC5D0\uC11C \uD65C\uC6A9\uB420 \uD50C\uB7AB\uD3FC\uC758 \uBCA0\uD0C0 \uBC84\uC804\uC744 \uAC1C\uBC1C\uD558\uC600\uC2B5\uB2C8\uB2E4. \uC774 \uD50C\uB7AB\uD3FC\uC740 \uBD84\uC0B0\uB41C \uB370\uC774\uD130\uB97C \uC911\uC559 \uC9D1\uC911\uD654\uD558\uC5EC \uC5C5\uBB34 \uD6A8\uC728\uC131\uC744 \uB192\uC774\uACE0 \uC758\uC0AC\uC18C\uD1B5\uC744 \uC6A9\uC774\uD558\uAC8C \uD558\uB294 \uAC83\uC744 \uBAA9\uC801\uC73C\uB85C \uD558\uC600\uC2B5\uB2C8\uB2E4.","image":"char.png"}]');



var $5X218 = parcelRequire("5X218");
const $ce7ad931d63f2bb7$var$$capstoneOngoingList = document.getElementById('capstone-ongoing-list');
const $ce7ad931d63f2bb7$var$$capstoneCompletedList = document.getElementById('capstone-completed-list');
const $ce7ad931d63f2bb7$var$$capstoneCompletedCarouselList = document.getElementById('capstone-completed-carousel-list');
const $ce7ad931d63f2bb7$var$ongoingHtml = (0, (/*@__PURE__*/$parcel$interopDefault($f39c45f83a337f54$exports))).filter((p)=>p.category === 'ONGOING').map((p, i)=>{
    return `
  <div
    class="flex flex-col-reverse justify-between gap-x-2 rounded-xs bg-white shadow-sm md:flex-row relative">
    <div class="flex flex-1 flex-col gap-4 p-8">
      <span class="text-5xl font-bold w-12 block text-center border-b pb-1.5 border-flamingo-500 text-zinc-300">${i + 1}</span>
      <div class="space-y-2">
        <p class="text-3xl font-semibold">${p.name}</p>
        <p class="font-medium">Client | Partner: ${p.client}</p>
      </div>
      <div class="space-y-2">
        <p class="text-zinc-600 italic">Term: ${p.duration}</p>
        <div class="flex gap-2">
          ${p.isApplicationOpen ? `<span class="rounded-full bg-sky-500 px-4 py-2 text-xs font-medium text-white uppercase">
                application open
              </span>
            ` : `
              <span class="rounded-full bg-zinc-200 px-4 py-2 text-xs font-medium text-zinc-400 uppercase">
                application closed
              </span>
            `}
        </div>
      </div>
      <p class="leading-7 break-keep whitespace-pre-line">${p.description}</p>
      <div class="flex gap-2 flex-col sm:flex-row">
          ${p.link ? `
            <a href="${p.link}" class="btn white !bg-zinc-800">
            <span>\u{C790}\u{C138}\u{D788} \u{BCF4}\u{AE30}</span>
            <span class="heroicons--arrow-long-right"></span>
          </a>
            ` : ''}
          ${p.isContact ? `
              <button
                type="button"
                data-modal-target="contactForm"
                data-modal-show="contactForm"
                class="btn white !bg-zinc-800">
                <span>\u{D504}\u{B85C}\u{ADF8}\u{B7A8} \u{C0C1}\u{B2F4}</span>
              </button>
              ` : ''}
            ${p.isApplicationOpen && p.form ? `
              <a href="${p.form}" target="_blank" class="btn white">
                <span>Apply Now</span>
                <span class="heroicons--arrow-long-right"></span>
              </a>
              ` : ''}
      </div>
    </div>
    <div class="flex-1">
      <img
        src="${(0, $5X218.imageMap)[p.image]}"
        alt="${p.name}"
        draggable="false"
        class="h-auto sm:h-full object-cover ${p.objectPosition === 'left' ? 'object-left' : 'object-center'}" />
    </div>
  </div>
`;
}).join('');
$ce7ad931d63f2bb7$var$$capstoneOngoingList.innerHTML = $ce7ad931d63f2bb7$var$ongoingHtml;
const $ce7ad931d63f2bb7$var$HIDDEN_PROJECTS = [
    'Project MU',
    'Project CUBS',
    'The Metaverse Project'
];
const $ce7ad931d63f2bb7$var$filteredCapstones = (0, (/*@__PURE__*/$parcel$interopDefault($f39c45f83a337f54$exports))).filter((p)=>p.category === 'COMPLETED' && !$ce7ad931d63f2bb7$var$HIDDEN_PROJECTS.includes(p.name));
const $ce7ad931d63f2bb7$var$completedCarouselHtml = $ce7ad931d63f2bb7$var$filteredCapstones.map((p)=>{
    return `
    <div
      data-carousel-item
      class="lg:px-8 hidden h-full overflow-hidden duration-300 ease-in-out">
      <div class="bg-zinc-50 flex md:flex-row flex-col h-full shadow-sm rounded-xs overflow-x-hidden overflow-y-auto">
        <div class="flex flex-col gap-2 p-8 flex-2/3">
          <h3 class="text-3xl font-semibold">${p.name}</h3>
          <p class="font-medium">Client | Partner: ${p.client}</p>
          ${p.deliverables ? `
            <div>
            <a href="${p.deliverables.url}" target="_blank" class="hover-transition border-zinc-800 text-flamingo-500 hover:text-flamingo-400 text-sm font-medium border-b">${p.deliverables.name}</a>
            </div>
            ` : ''}
          <p class="mt-4 text-sm italic text-zinc-600">Term: ${p.duration}</p>
          <p class="mt-4 leading-7 break-keep">
            ${p.description}
          </p>
        </div>
        <div class="flex-1/2 bg-white">
          <img 
            src="${(0, $5X218.imageMap)[p.image]}"
            alt="${p.name}"
            class="h-auto sm:h-full ${p.objectFit === 'contain' ? 'object-contain' : 'object-cover'}" />
        </div>
      </div>
    </div>
  `;
}).join('');
$ce7ad931d63f2bb7$var$$capstoneCompletedCarouselList.innerHTML = $ce7ad931d63f2bb7$var$completedCarouselHtml;
const $ce7ad931d63f2bb7$var$completedHtml = $ce7ad931d63f2bb7$var$filteredCapstones.map((p)=>{
    return `
    <div class="bg-zinc-50 flex flex-col-reverse h-full shadow-sm rounded-xs overflow-x-hidden overflow-y-auto">
      <div class="flex flex-col gap-2 p-8 flex-2/3">
        <h3 class="text-3xl font-semibold">${p.name}</h3>
        <p class="font-medium">Client | Partner: ${p.client}</p>
        ${p.deliverables ? `
          <div>
          <a href="${p.deliverables.url}" target="_blank" class="hover-transition border-zinc-800 text-flamingo-500 hover:text-flamingo-400 text-sm font-medium border-b">${p.deliverables.name}</a>
          </div>
          ` : ''}
        <p class="mt-4 text-sm italic text-zinc-600">Term: ${p.duration}</p>
        <p class="mt-4 leading-7 break-keep">
          ${p.description}
        </p>
      </div>
      <div class="flex-1/2 bg-white">
        <img 
          src="${(0, $5X218.imageMap)[p.image]}"
          alt="${p.name}"
          class="h-auto w-full ${p.objectFit === 'contain' ? 'object-contain' : 'object-cover'}" />
      </div>
    </div>
  `;
}).join('');
$ce7ad931d63f2bb7$var$$capstoneCompletedList.innerHTML = $ce7ad931d63f2bb7$var$completedHtml;


//# sourceMappingURL=capstone.c672755f.js.map
